var _path;
import * as React from "react";
function SvgComboInsightsHorizontalBorderPositive(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.505 6.766A2.5 2.5 0 0157.5 9.215V33a1.5 1.5 0 01-1.5 1.5H4A1.5 1.5 0 012.5 33V9.215a2.5 2.5 0 011.995-2.449l25.202-5.193a1.5 1.5 0 01.606 0l25.202 5.193z"
  })));
}
export default SvgComboInsightsHorizontalBorderPositive;